import { makeObservable, observable, flow, computed } from "mobx";
import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import { Add } from "@/components/icons/IconMap";

import BrowseNotificationLogsSchema from "@/areas/workflows/schemas/BrowseNotificationLogsSchema";
import { RefreshCcw } from "lucide-react";

export default class BrowseNotificationLogsStore {
  loading = true;
  pagination = null;
  logs = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      pagination: observable,
      logs: observable,
      actions: computed,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  get actions() {
    const list = [];

    // list.push({
    //   id: "workflow:notification-log:refresh",
    //   label: "Refresh",
    //   onClick: () => this.load({}),
    //   icon: RefreshCcw,
    //   location: "primary",
    //   processing: this.loading,
    //   disabled: this.loading,
    // });

    return list;
  }

  *load(query, options) {
    const parseResult = BrowseNotificationLogsSchema.safeParse(query);
    if (!parseResult.success) {
      console.error(parseResult.error);
      return parseResult;
    }

    try {
      this.loading = true;
      const response = yield api.post(ApiRoutes.forNotificationLogSearch(), { ...query });
      this.logs = response.data.items;
      this.pagination = {
        page: response.data.page,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        pageSize: response.data.pageSize,
      };
      return { success: true, data: response.data };
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
